import { useState, useEffect, useCallback, useRef  } from "react";
import "./MuxActions.css";
import UploadAction from "./MuxUploadAction";
import PlayAction from "./MuxPlayAction";
import DownloadAction from "./MuxDownloadAction";
import DeleteAction from "./MuxDeleteAction";
import CancelUploadAction from "./MuxCancelUploadAction";
import { useRefreshProtection } from "./RefreshProtection";

import { toast } from 'react-toastify'; 

function MuxActions({ item, onSongUpdate }: any) {
  const [localItem, setLocalItem] = useState(item);
  const [isRefreshing, setIsRefreshing] = useState(false);
  
  const [isUploading, setIsUploading] = useState(false);
  const isUploadingRef = useRef(false);

  useRefreshProtection();

  useEffect(() => {
    setLocalItem(item);
  }, [item]);

  useEffect(() => {
    isUploadingRef.current = isUploading;
  }, [isUploading]);

const handleUploadSuccess = useCallback((updatedTalktape: any) => {
  setLocalItem((prev: any) => ({ 
    ...prev, 
    ...updatedTalktape,
    status: "waiting" 
  }));
  
  setTimeout(() => {
    setIsRefreshing(false);
    toast.info("Upload complete! Please refresh the page to see the updated status when all the videos are uploaded.");
  }, 2000);

  if (typeof onSongUpdate === "function") {
    onSongUpdate(updatedTalktape);
  }
}, [onSongUpdate]);

const hasTalktape = localItem.mux_playback_id || localItem.status === "ready";
const isProcessing = localItem.status === "waiting" || localItem.status === "pending" || localItem.status === "error" || isRefreshing;

const canPlaybackTalktape = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m:any) => m.title.toLowerCase() === "talktape")?.ModulesPermissions?.view;
const canAddTalktape = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m:any) => m.title.toLowerCase() === "talktape")?.ModulesPermissions?.add;
const canDownloadTalktape = canAddTalktape;
const canDeletekTalktape = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m:any) => m.title.toLowerCase() === "talktape")?.ModulesPermissions?.delete;
//console.log("canDownloadTalktape --- ", canDownloadTalktape);console.log("canDeletekTalktape --- ", canDeletekTalktape);console.log("canPlaybackTalktape --- ", canPlaybackTalktape);

const canCancelUpload = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const userId = user.id;
  const uploadHistory = JSON.parse(localStorage.getItem("upload_history") || "{}");
  const historyEntry = uploadHistory[item.performance_id];
  const canCancelHistory = historyEntry && historyEntry.userId === userId;
  return canCancelHistory && canAddTalktape;
}

return (
  <div className="music-actions">
    {hasTalktape ? (
      <div className="uploaded-state">
        
        {canPlaybackTalktape && (
          <PlayAction item={localItem} />
        )}

        <div className="actions-buttons">
          {canDownloadTalktape && (
            <DownloadAction item={localItem} />
          )}
          
          {canDeletekTalktape && (
          <DeleteAction
            item={localItem}
            onUpdate={(updatedTalktape: any) => {
              setLocalItem((prev: any) => ({ ...prev, ...updatedTalktape }));
              if (typeof onSongUpdate === "function") onSongUpdate(updatedTalktape);
            }}
          />
          )}

        </div>
      </div>
    ) : (
      <div className="not-uploaded-state">
        {isProcessing ? (
        <div>
          <span className="upload-progress">Processing...</span>
          {canCancelUpload() && (
            <CancelUploadAction
              item={localItem}
              onUpdate={(updatedTalktape: any) => {
                setLocalItem((prev: any) => ({ ...prev, ...updatedTalktape }));
                if (typeof onSongUpdate === "function") onSongUpdate(updatedTalktape);
              }}
            />
          )}
        </div>
        ) : (
          canAddTalktape && (
            <UploadAction 
              item={localItem}
              onSuccess={handleUploadSuccess}
              onUploadStatusChange={setIsUploading}
            />
          )
        )}
      </div>
    )}
  </div>
);
}

export default MuxActions;